import Task from '../../../lib/html5-software-library/src/ranj/util/executor/Task';
import AppSignalService from './AppSignalService';

export default class InitAppSignalTask extends Task {
    /**
     * @constructor
     * @param {AppSignalService} appSignalService 
     */
    constructor(appSignalService) {
        super();

        this._appSignalService = appSignalService;
    }

    execute(callback, progressCallback) {
        this._initAppSignal(callback);
    }

    _initAppSignal(callback) {
        this._appSignalService.connect()
            .then(() => {
                console.log(`InitAppSignalTask completed.`);
                callback(this);

                // console.log(`Throwing an error on purpose to test AppSignal integration...`);
                // this.throwErrorOnPurposeToTestAppSignalIntegration();
            });
    }
}